import request from '@/utils/request'

// 所有的评级标准数据
export  function webGetAllRatingCriteria(data){
    return request({
        url:'/xchk/ratingCriteria/webGetAllRatingCriteria',
        method:'POST',
        data
    })
}


// WEBPACK FOOTER //
// ./src/api/ratingCriteria.js